import {
  ContainerEntity,
  ContainerSelectorProps,
  containersSelector,
  useGetAllContainersQuery
} from "@ots-frontend/ots-data";
import {BaseContainerMultiSelect, BaseContainerMultiSelectProps} from "./BaseContainerMultiSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type ContainerMultiSelectProps = Omit<BaseContainerMultiSelectProps, "entities" | "loading"> & {
  selector?: ContainerSelectorProps
}

export const ContainerMultiSelect = (props: ContainerMultiSelectProps) => {
  const {
    selector,
    ...rest
  } = props;

  const selectContainers = useMemo(() => {
    return containersSelector()
  }, []);

  const {containers, isLoading} = useGetAllContainersQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      containers: selectContainers(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseContainerMultiSelect entities={containers} loading={isLoading} {...rest} />;
};

export interface ContainerMultiSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: ContainerMultiSelectProps,
  onSubmit?: (containers: ContainerEntity[] | undefined) => void
}

export const ContainerMultiSelectModal = (props: ContainerMultiSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedContainers, setSelectedContainers] = useState<ContainerEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <ContainerMultiSelect
          {...select}
          onEntityChange={e => setSelectedContainers(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedContainers);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
